import React from "react";
import "./style.css";

/**
 * @typedef {Object} ClientDetails
 * @property {string} name
 * @property {string} email
 * @property {string} address
 * @property {string} phone
 * @property {string} mobile
 * @property {string} fax
 */

/**
 * @param {{
 * 	data: ClientDetails,
 * 	onChange: (data: ClientDetails) => void
 * }} props
 */
export default function ClientDetailsForm({ data, onChange }) {
	const handleChange = (field, value) => {
		onChange({ ...data, [field]: value });
	};

	return (
		<div className="invoice-section">
			<h3 className="invoice-section-title">Bill To (Client)</h3>

			<div className="client-grid">
				<div className="field">
					<label className="label" htmlFor="client-name">
						Client Name
					</label>
					<input
						id="client-name"
						className="invoice-input"
						type="text"
						placeholder="Client or Company Name"
						value={data.name || ""}
						onChange={(e) => handleChange("name", e.target.value)}
					/>
				</div>

				<div className="field">
					<label className="label" htmlFor="client-email">
						Email
					</label>
					<input
						id="client-email"
						className="invoice-input"
						type="email"
						placeholder="client@email.com"
						value={data.email || ""}
						onChange={(e) => handleChange("email", e.target.value)}
					/>
				</div>

				<div className="field field--full">
					<label className="label" htmlFor="client-address">
						Address
					</label>
					<input
						id="client-address"
						className="invoice-input"
						type="text"
						placeholder="Client Address"
						value={data.address || ""}
						onChange={(e) => handleChange("address", e.target.value)}
					/>
				</div>

				<div className="field">
					<label className="label" htmlFor="client-phone">
						Phone
					</label>
					<input
						id="client-phone"
						className="invoice-input"
						type="tel"
						placeholder="+27 12 345 6789"
						value={data.phone || ""}
						onChange={(e) => handleChange("phone", e.target.value)}
					/>
				</div>

				<div className="field">
					<label className="label" htmlFor="client-mobile">
						Mobile
					</label>
					<input
						id="client-mobile"
						className="invoice-input"
						type="tel"
						placeholder="+27 12 345 6789"
						value={data.mobile || ""}
						onChange={(e) => handleChange("mobile", e.target.value)}
					/>
				</div>

				<div className="field">
					<label className="label" htmlFor="client-fax">
						Fax
					</label>
					<input
						id="client-fax"
						className="invoice-input"
						type="text"
						placeholder="+27 12 345 6789"
						value={data.fax || ""}
						onChange={(e) => handleChange("fax", e.target.value)}
					/>
				</div>
			</div>
		</div>
	);
}
